import React from 'react'
import KeyWordItem from './KeyWordItem'
import { KeyWordTypeEnum } from '@types'

const subComponentOptions = [
  { key: 'customerService', type: KeyWordTypeEnum.customerService },
  { key: 'client', type: KeyWordTypeEnum.client },
]

const KeyWord: React.FC = () => {
  return (
    <div className="key-word-page">
      {subComponentOptions.map(({ key, type }) => (
        <KeyWordItem
          key={key}
          type={type}
        />
      ))}
    </div>
  )
}

export default KeyWord
